/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlockedCompany
 */
export interface BlockedCompany {
    /**
     * ブロックした企業の企業ID
     * @type {number}
     * @memberof BlockedCompany
     */
    companyId: number;
    /**
     * ブロックした企業の企業名
     * @type {string}
     * @memberof BlockedCompany
     */
    companyName: string;
    /**
     * ブロックした企業のロゴ画像URL
     * @type {string}
     * @memberof BlockedCompany
     */
    logoImageUrl: string | null;
    /**
     * ブロックした企業の企業概要
     * @type {string}
     * @memberof BlockedCompany
     */
    description: string | null;
}

export function BlockedCompanyFromJSON(json: any): BlockedCompany {
    return BlockedCompanyFromJSONTyped(json, false);
}

export function BlockedCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockedCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'logoImageUrl': json['logo_image_url'],
        'description': json['description'],
    };
}

export function BlockedCompanyToJSON(value?: BlockedCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'company_name': value.companyName,
        'logo_image_url': value.logoImageUrl,
        'description': value.description,
    };
}

